import React from "react";

import { Label } from "@client/shadcn/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@client/shadcn/ui/card";
import { Badge } from "@client/shadcn/ui/badge";
import { Progress } from "@client/shadcn/ui/progress";
import { AspectRatio } from "@client/shadcn/ui/aspect-ratio";
import { ProjectEdit } from "./ProjectEdit";
import { Editor } from "@client/shadcn/lexical/blocks/editor-00/editor";
import _ from "lodash";
import { SerializedEditorState } from "lexical";
import { ProjectDetail } from "@client/components/ProjectDetail";

interface Props {
    className?: string;
    id: number;
    title: string;
    details: object;
    coverImage?: string;
    status: string;
    progress: number;
    tags: {name: string}[];
    canEdit: boolean;
}

export const ProjectCard = (props: Props) => {
    return (
        <Card className="pt-0 overflow-hidden h-full relative">
            <CardHeader className="px-0">
                <AspectRatio ratio={1 / 1} className="h-full w-full flex items-center justify-center bg-gradient-to-r from-gray-200 to-gray-300">
                    {props.coverImage ? 
                        <img src={props.coverImage} alt={props.title}/> :
                        <Label className="text-gray-500 text-4xl font-medium">{props.title.charAt(0)}</Label>
                    }
                    <div className="absolute top-2 right-2">
                        <Badge>{props.status}</Badge>
                    </div>
                </AspectRatio>
            </CardHeader>

            <CardContent>
                <CardTitle>
                    <Label className="text-lg font-semibold line-clamp-2">{props.title}</Label>
                </CardTitle>
                <CardDescription className="line-clamp-3">
                    <Editor
                        editorSerializedState={_.isEmpty(props.details) ? undefined : props.details as SerializedEditorState}
                        readOnly={true}
                        className="line-clamp-3"
                    />
                </CardDescription>
            </CardContent>
            
            <div className="flex-1"></div>

            <CardFooter className="gap-2 items-end">
                <div className="flex-1">
                    <div className="flex justify-between text-xs">
                        <Label className="text-xs">Progress</Label>
                        <Label className="text-xs">{props.progress}%</Label>
                    </div>
                    <Progress value={props.progress} className="h-2" />
                </div>
                <div className="flex-1 flex justify-end flex-wrap gap-1 basis-1/4">
                    {props.tags.map((tag) => (
                        <Badge key={tag.name} variant="outline" className="text-xs">{tag.name}</Badge>
                    )) || <Badge className="invisible"/>}
                </div>
            </CardFooter>
            <ProjectDetail id={props.id}/>
            <div className="absolute top-2 left-2">
                {props.canEdit ? <ProjectEdit id={props.id}/> : null}
            </div>
        </Card>
    );
};
